export default "__VITE_ASSET__85a24066__"